import React from "react"

function IconCircleLoadSpinner({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg fill={color} fuze-icon="circle-load-spinner" width="24px" height="24px" viewBox="0 0 24 24" {...props}>
      <path
        d="M12,2.5 C17.2467051,2.5 21.5,6.75329488 21.5,12 C21.5,17.2467051 17.2467051,21.5 12,21.5 C6.75329488,21.5 2.5,17.2467051 2.5,12 C2.5,6.75329488 6.75329488,2.5 12,2.5 Z M12,5.66666667 C8.50219658,5.66666667 5.66666667,8.50219658 5.66666667,12 C5.66666667,15.4978034 8.50219658,18.3333333 12,18.3333333 C15.4978034,18.3333333 18.3333333,15.4978034 18.3333333,12 C18.3333333,8.50219658 15.4978034,5.66666667 12,5.66666667 Z"
        opacity="0.196243641"
      ></path>
      <path
        d="M12,2.5 C17.2467051,2.5 21.5,6.75329488 21.5,12 C21.5,12.2666202 21.4890166,12.5306751 21.4674775,12.7917369 L18.2843441,12.7915867 C18.3166775,12.5322669 18.3333333,12.2680786 18.3333333,12 C18.3333333,8.50219658 15.4978034,5.66666667 12,5.66666667 L12,2.5 Z"
        opacity="0.3"
      ></path>
    </svg>
  )
}

export default IconCircleLoadSpinner
